import { render, staticRenderFns } from "./ToggleBtn.vue?vue&type=template&id=5224c012&scoped=true"
import script from "./ToggleBtn.vue?vue&type=script&lang=js"
export * from "./ToggleBtn.vue?vue&type=script&lang=js"
import style0 from "./ToggleBtn.vue?vue&type=style&index=0&id=5224c012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224c012",
  null
  
)

export default component.exports